enum ClassificacaoAsaEnum {
  ClassificacaoAsa1 = 'ClassificacaoAsa1',
  ClassificacaoAsa2 = 'ClassificacaoAsa2',
  ClassificacaoAsa3 = 'ClassificacaoAsa3',
  ClassificacaoAsa4 = 'ClassificacaoAsa4',
  ClassificacaoAsa5 = 'ClassificacaoAsa5',
  ClassificacaoAsa6 = 'ClassificacaoAsa6',
}

export default ClassificacaoAsaEnum
